import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'underscore';
import get from 'lodash/get';
import { favoriteDel, favoriteAdd } from 'services/api/user/favorite';
import { getCommonNode } from '../../../selectors/detailPage/content';
import { getChannelMetadata } from '../../../selectors/detailPage/epgChannel';
import { converter } from 'helpers/converter';
import * as actions from 'actions/response';
import * as constants from 'constants.js';
import * as caruselActions from 'action-creators/carousel';
import * as actionsMetrics from 'action-creators/metrics';

export class BtnCardFavorite extends React.Component {
  setMetrics(label, action) {
    const eventCategory = 'vcard';
    const eventAction = action;
    const eventLabel = label;

    this.props.setMetricsEvent({
      tagManager: {
        event: 'click',
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  validateSerie(serie) {
    const s = serie;
    const isSerie = med => !!med.serie;
    const media = ext => (ext.media ? isSerie(ext.media) : false);
    return s && s.extendedcommon ? media(s.extendedcommon) : false;
  }

  onClick(group) {
    let eventLabel;
    let eventAction;
    let genero = null;
    const { contentDataEvent, favorites, user } = this.props;
    let { contentData } = this.props;
    if (contentData === undefined) contentData = contentDataEvent;
    const isSerie = this.validateSerie(contentData);

    const queryParams = {
      title: contentData.title,
      titleUri: contentData.title_uri,
    };

    if (get(contentData, 'extendedcommon.genres', false)) {
      genero = contentData.extendedcommon.genres.genre[0].desc;
      queryParams.genero = genero;
    }
    let type = get(contentData, 'extendedcommon.format.sell_type', '');
    if (type === 'susc') {
      type = contentData.extendedcommon.media.proveedor.nombre;
      if (type === 'AMCO') type = 'susc';
    }

    const isFavorite = _.findIndex(favorites, { id: group.id }) !== -1;
    const isFavoriteNew = !isFavorite;
    const { userhash } = user;
    group.user_hash = userhash;
    const params = {
      object_id: group.id,
      user_hash: userhash,
      object_type: 1,
    };

    if (isFavoriteNew) {
      this.props.onFavoriteAdd(group, params);
      eventAction = 'Agregar Por Ver';
    } else {
      this.props.onFavoriteRemove(group, params);
      eventAction = 'Quitar Por Ver';
    }

    if (isSerie) {
      const nameSerie = get(
        contentData,
        'extendedcommon.media.serie.title',
        '',
      );
      eventLabel = `${queryParams.genero} - ${nameSerie} | ${
        contentData.title
      } - ${type}`;
    } else {
      eventLabel = `${queryParams.genero} - ${contentData.title} - ${type}`;
    }

    this.setMetrics(eventLabel, eventAction);
  }

  render() {
    const { contentDataEvent } = this.props;
    let { contentData } = this.props;
    let isLoading = false;

    if (contentData === undefined) contentData = contentDataEvent;
    if (contentData === null || contentData === undefined) {
      return <div />;
    }

    if (contentData.id == null) {
      contentData.id = contentData.group_id;
    }

    if (this.props.user.userType == constants.ANONYMOUS_USER) {
      return null;
    }

    if (this.props.favorites == null) {
      isLoading = true;
    }

    const isFavorite =
      _.findIndex(this.props.favorites, { id: contentData.id }) != -1;

    return (
      <button
        className="btn btn-default btn-lg"
        onClick={this.onClick.bind(this, contentData)}
      >
        <span className="text-inline">
          {converter.convertApaUnicode(
            this.props.translations,
            'btn_add_fav_list',
            'Por ver',
          )}
        </span>
        {isLoading && <i className="fa fa-refresh fa-spin icon-inline" style={{marginLeft: '10px'}}/>}
        {!isLoading && !isFavorite && (
          <i className="fa fa-plus-circle icon-inline"  style={{marginLeft: '10px'}}/>
        )}
        {!isLoading && isFavorite && (
          <i className="fa fa-minus-circle icon-inline"  style={{marginLeft: '10px'}}/>
        )}
      </button>
    );
  }
}

BtnCardFavorite.propTypes = {
  translations: PropTypes.object,
  favorites: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object,
  contentData: PropTypes.object,
  contentDataEvent: PropTypes.object,
  onFavoriteAdd: PropTypes.func,
  onFavoriteRemove: PropTypes.func,
  setMetricsEvent: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  favorites: state.favorites,
  user: state.user,
  translations: state.translations,
  contentData: getCommonNode(state),
  contentDataEvent: getChannelMetadata(state),
});

const mapDispatchToProps = dispatch => ({
  onFavoriteAdd(group, params) {
    dispatch(actions.addFavorite(group));
    dispatch(favoriteAdd(params));
  },
  onFavoriteRemove(group, params) {
    dispatch(caruselActions.deleteFavorite(group.id));
    dispatch(actions.removeFavorite(group));
    dispatch(favoriteDel(params));
  },
  setMetricsEvent(options) {
    dispatch(actionsMetrics.setMetricsEvent(options));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BtnCardFavorite);
